import serviceBase from '../../../../Services/serviceBase'

class WelcomeActions {
  getWelcomeMessage = async (legacyId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message/${legacyId}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getWelcomeMessagePreview = async (legacyId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message-preview/${legacyId}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  postWelcomeMessage = async (iarMember, jsonData, hardPublish) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message`

    return serviceBase
      .post(url, jsonData, { fullusername: iarMember.fullName, ishardpublish: hardPublish })
      .then(
        (response) => {
          return response
        },
        (err) => {
          console.log(err)
          return 'error'
        }
      )
  }

  postPublishWelcomeMessage = async (fireDepartmentIdentifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message-preview/publish/${fireDepartmentIdentifier}`
    return serviceBase.post(url).then(
      (response) => {
        return response.data
      },
      (err) => {
        console.log(err)
        return 'error'
      }
    )
  }

  postWelcomeMessagePreview = async (iarMember, jsonData) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message-preview`

    return serviceBase.post(url, jsonData, { fullusername: iarMember.fullName }).then(
      (response) => {
        return response
      },
      (err) => {
        console.log(err)
        return 'error'
      }
    )
  }

  getWelcomeMessageEmitStart = async (fireDepartment) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message`
    serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}`)
  }

  postPreviewToPublish = async (fireDepartment, iarMember) => {
    let url = `${window._env_.COMMUNITY_API_URL}/welcome-message-preview/preview-to-publish/${fireDepartment.identifier}`

    return serviceBase.post(url, null, { fullusername: iarMember.fullName }).then(
      (response) => {
        return response
      },
      (err) => {
        console.log(err)
        return 'error'
      }
    )
  }
}

export default new WelcomeActions()
